import { createReducer, on } from '@ngrx/store';
import { initialState } from './tenant-store.state';
import * as TenantActions from './tenant-store.actions';

export const tenantReducer = createReducer(
  initialState,
  on(TenantActions.tenantChanged, (state, result) => ({
    ...state,
    currentTenant: state.tenants.find((x) => x.hashId === result.tenantId) ?? null,
    isGlobalTenant: false,
  })),
  on(TenantActions.tenantsRequestedSuccess, (state, result) => ({
    ...state,
    tenants: state.tenants.concat(result.tenants),
    currentTenant: result.tenants[0] ?? null,
  })),
  on(TenantActions.globalTenantActivated, (state) => ({
    ...state,
    isGlobalTenant: true,
  })),
  on(TenantActions.globalTenantDeactivated, (state) => ({
    ...state,
    currentTenant: state.tenants[0] ?? null,
    isGlobalTenant: false,
  }))
);
